import { getTrialCost } from "@/Components/UI/Onboarding/Client/trialCost";
import { Client } from "@/types/page";
import { Price } from "@/types/price";
import { PricingVersion } from "@/types/pricingVersion";
import { PromotionCode } from "@/types/PromotionCode";
import pluralize from "@/utils/plural";

type V11PricingCardProps = {
    price: Price;
    pricingVersion: PricingVersion;
    promotionCode: PromotionCode | null;
    client: Client;
    trialDays: number;
    /** The rate the client used to pay, struck through beside the current one. */
    weeklyPriceBeforeDiscount?: string | null;
};

export function V11PricingCard(props: V11PricingCardProps) {
    const {
        baseAmountForDisplay: trialBaseAmountForDisplay,
        costAfterPromoForDisplay,
    } = getTrialCost(props);

    return (
        <div
            data-testid="pricing-explanation-container"
            className="rounded-lg border border-brand-border p-4 text-brand-black text-md sm:text-lg"
        >
            {props.trialDays === 0 ? (
                <div data-testid="pricing-and-interval">
                    <span className="font-bold">
                        Cost:{" "}
                        {!!props.weeklyPriceBeforeDiscount && (
                            <span className="line-through">
                                {props.weeklyPriceBeforeDiscount}
                            </span>
                        )}{" "}
                        {props.price.amountPerSessionForDisplay}/week
                    </span>
                    <div data-testid="pricing-includes" className="italic">
                        Includes weekly video sessions + messaging
                    </div>
                </div>
            ) : (
                <>
                    {props.promotionCode ? (
                        <div>
                            <span className="font-bold">
                                Cost today:{" "}
                                <span className="line-through">
                                    {trialBaseAmountForDisplay}
                                </span>{" "}
                                {costAfterPromoForDisplay}
                            </span>{" "}
                            for 1 week trial
                        </div>
                    ) : (
                        <div data-testid="pricing-and-interval">
                            <span className="font-bold">
                                Cost today: {trialBaseAmountForDisplay}
                            </span>{" "}
                            for 1 week trial
                        </div>
                    )}
                    <div data-testid="pricing-includes" className="italic">
                        Includes video session + messaging
                    </div>
                    <div
                        data-testid="pricing-after-trial-per-week"
                        className="font-bold mt-4"
                    >
                        After 1 week trial:{" "}
                        {!!props.weeklyPriceBeforeDiscount && (
                            <span className="line-through">
                                {props.weeklyPriceBeforeDiscount}
                            </span>
                        )}{" "}
                        {props.price.amountPerSessionForDisplay}
                        /week
                    </div>
                </>
            )}
            <div data-testid="pricing-billed-amount" className="italic">
                Billed as {props.price.amountForDisplay} every{" "}
                {pluralize(props.price.intervalCount, props.price.interval)}
            </div>
        </div>
    );
}
